import { useParams } from "react-router-dom";
import ProfileSettings from "./ProfileSettings";

const Settings = () => {
  const { tab = "profile" } = useParams();

  return (
    <div className="space-y-6 w-full max-w-[1310px] mx-auto px-4 sm:px-0">
      {/* Page Header */}
      <div>
        <h1 className="text-xl sm:text-2xl font-semibold tracking-tight">Settings</h1>
      </div>

      <div className="space-y-6">
        {tab === "profile" && (
          <div className="mt-0 outline-none">
            <ProfileSettings />
          </div>
        )}
      </div>
    </div>
  );
};

export default Settings;
